import { computed } from "vue";
import { getLanguageFromPath } from "./../helpers/index.mjs";
import { useRoute, useRuntimeConfig } from "#imports";
import { isValidLanguage } from "#language-negotiation/language";
export function useCurrentLanguage() {
  const route = useRoute();
  const config = useRuntimeConfig().public.languageNegotiation;
  const currentLanguage = computed(() => {
    const languagePath = getLanguageFromPath(route.path);
    if (languagePath && isValidLanguage(languagePath)) {
      return languagePath;
    }
    return config.defaultLanguage;
  });
  return currentLanguage;
}
